import * as React from "react";
import { Typography, Button } from "antd";
import SelectInput from "../../app/SelectInput";
import { IReportingPeriodItem } from "../../../../model/report/ReportingPeriodItem";
import { TTranslate } from "../../../../service/locale/TranslationService";
import MultiSelect from "../../app/MultiSelect";
import { IReport8ApplicantPresentationModel } from "../../../../presenter/report/model/Report8ApplicantPresentationModel";

export interface State {
  selectedApplicants: number[];
}
export interface Props {
  currentReportingPeriod?: IReportingPeriodItem;
  reportingPeriodList: IReportingPeriodItem[];
  onChangeReportingPeriod(reportingPeriodId: number): void;
  applicants: IReport8ApplicantPresentationModel[];
  getPDFReport: any;
  translate: TTranslate;
  loading?: boolean;
  title?: string;
  onApplicantsChange: (values: any[]) => void;
  selectedApplicantIds: number[];
  onApplicantSearch: (fullName: string) => void;
}

export default class Report8ParamsBox extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { ...props, selectedApplicants: [] };
  }

  setSelectedApplicants(id: number) {
    const { selectedApplicants } = this.state;
    let newSelectedApplicants: number[] = [];
    if (selectedApplicants.includes(id)) {
      newSelectedApplicants = selectedApplicants.filter(
        selected => selected !== id
      );
    } else {
      newSelectedApplicants = ([] as any[]).concat(id);
    }
    this.setState({ selectedApplicants: newSelectedApplicants });
  }
  render() {
    const {
      currentReportingPeriod,
      reportingPeriodList,
      onChangeReportingPeriod,
      applicants,
      getPDFReport,
      translate,
      loading,
      title,
      onApplicantsChange,
      selectedApplicantIds,
      onApplicantSearch
    } = this.props;
    return (
      <div className={"report-sidebar"}>
        <div className={"report-param-title "}>
          <Typography.Title style={{ fontSize: 14 }}>{title}</Typography.Title>
          <SelectInput
            value={currentReportingPeriod?.id.toString()}
            placeholder={translate("reports.params.placeholder")}
            selectOptions={reportingPeriodList}
            selectOptionKey={"id"}
            selectOptionValue={"name"}
            style={{ width: "100%" }}
            onChange={e => {
              onChangeReportingPeriod(parseInt(e, 10));
            }}
            defaultActiveFirstOption={false}
            showSearch={true}
            notFoundContent={translate("search.no_data")}
          />
          <div style={{ marginTop: 20 }}>
            <Typography.Title style={{ fontSize: 14 }}>
              {translate("report8.applicants")}
            </Typography.Title>
            <MultiSelect
              mode={"multiple"}
              options={applicants}
              selectOptionKey={"id"}
              selectOptionValue={"fullName"}
              onChange={onApplicantsChange}
              placeholder={translate("report8.applicants_placeholder")}
              value={selectedApplicantIds}
              style={{ width: "100%" }}
              notFoundContent={translate("search.no_data")}
              onSearch={(value: string) => onApplicantSearch(value)}
            />
          </div>
        </div>

        <Button
          type="primary"
          onClick={() => getPDFReport()}
          loading={loading}
          disabled={currentReportingPeriod ? false : true}
          className={"report-btn"}
        >
          {translate("reports.show")}
        </Button>
      </div>
    );
  }
}
